import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { yearOptions } from "../../../config";
import { tableConfig, transformChartData } from "./config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";
import CardBiaxialChart from "../../../../../../cards/BiaxialChart";
//  type = 'service' | 'entri'

export default class LaporanUnitL3Y extends Component {
  constructor(props) {
    super(props);
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      year: yearOptions.find((item) => item.value === this.currentYear),
      menuName: null,
      dataTable: [],
      chartVisibility: false,
    };
  }

  componentDidMount() {
    this.setState({
      menuName: this.getTitle(),
    });
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    const currCabang = this.props?.kodeCabang;
    const prevCabang = prevProps?.kodeCabang;
    const currSearch = this.props?.doSearch;
    const prevSearch = prevProps?.doSearch;

    if (
      JSON.stringify(currCabang) !== JSON.stringify(prevCabang) ||
      (currSearch && currSearch !== prevSearch)
    ) {
      this.fetchData();
    }
  }

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = () => {
    const { type } = this.props;

    if (type === "unit_entri") {
      return this.fetchUnitEntriL3Y();
    }
    return this.fetchUnitServisNonKpbL3Y();
  };

  getTitle = () => {
    const { type } = this.props;
    let title = null;
    switch (type) {
      case "service":
        title = "LAPORAN UNIT SERVICE 3 TAHUN TERAKHIR";
        break;
      case "unit_entri":
        title = "LAPORAN UNIT ENTRI 3 TAHUN TERAKHIR";
        break;

      default:
        title = null;
        break;
    }
    return title;
  };

  fetchUnitEntriL3Y = async () => {
    const { setError, onTriggerLoading, kodeCabang, onSuccess } = this.props;
    const { year } = this.state;
    if (!kodeCabang) return;

    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitEntryLastThreeYearH23,
      setError: setError,
      menuName:
        "Dashboard Level Kabeng Keatas - Laporan Unit Entri 3 Tahun Terakhir",
      args: {
        year: year?.value,
        kodeCabang: kodeCabang,
        employeeIdMechanic: null,
      },
    });

    onTriggerLoading();
    onSuccess();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  fetchUnitServisNonKpbL3Y = async () => {
    const { setError, onTriggerLoading, kodeCabang, onSuccess } = this.props;
    const { year } = this.state;
    if (!kodeCabang) return;

    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO")
          .getLaporanUnitServisNonKpbLastThreeYear,
      setError: setError,
      menuName:
        "Dashboard Level Kabeng Keatas - Laporan Unit Servis Non KPB 3 Tahun Terakhir",
      args: {
        year: year?.value,
        listCabang: kodeCabang,
      },
    });

    onTriggerLoading();
    onSuccess();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data?.map((item) => ({
          employeeNameMechanic: item.cabang,
          y2q1: item.q1Y2,
          y2q2: item.q2Y2,
          y2q3: item.q3Y2,
          y2q4: item.q4Y2,
          y1q1: item.q1Y1,
          y1q2: item.q2Y1,
          y1q3: item.q3Y1,
          y1q4: item.q4Y1,
          yq1: item.q1Y,
          yq2: item.q2Y,
          yq3: item.q3Y,
          yq4: item.q4Y,
        })),
      });
    }
  };

  getHeaderPrint = (data) => {
    const { type } = this.props;
    return data.map((item) => {
      if (type === "service" && item.name === "employeeNameMechanic") {
        return "Cabang";
      } else if (item.name === "employeeNameMechanic") {
        return "Nama Mekanik";
      } else {
        return item.label;
      }
    });
  };

  handlePrint = async () => {
    const { onTriggerLoading, type, setError } = this.props;
    const { dataTable } = this.state;

    const title =
      type === "service"
        ? "Laporan Unit Service 3 Tahun Terakhir"
        : "Laporan Unit Entri 3 Tahun Terakhir";

    const fileName = title.split(" ").join("_");

    const dataName = type === "service" ? "Cabang" : "Nama Mekanik";
    
    const reqBody = {
      filename: fileName,
      sheets: [
        {
          name: title,
          headers: this.getHeaderPrint(tableConfig),
          data: dataTable.map((item) => ({
            [dataName]: item.employeeNameMechanic,
            "Q1 Y-2": item.y2q1,
            "Q2 Y-2": item.y2q2,
            "Q3 Y-2": item.y2q3,
            "Q4 Y-2": item.y2q4,
            "Q1 Y-1": item.y1q1,
            "Q2 Y-1": item.y1q2,
            "Q3 Y-1": item.y1q3,
            "Q4 Y-1": item.y1q4,
            "Q1 Y": item.yq1,
            "Q2 Y": item.yq2,
            "Q3 Y": item.yq3,
            "Q4 Y": item.yq4,
          })),
        },
      ],
    };
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Unit 3 Tahun Terakhir",
      args: reqBody,
    });

    onTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName + ".xlsx");
    }
  };

  handleChartVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      chartVisibility: !prev.chartVisibility,
    }));
  };

  renderContent() {
    const { dataTable, chartVisibility, type } = this.state;

    if (chartVisibility) {
      const { data, dataKey } = transformChartData(dataTable, type);
      return <CardBiaxialChart data={data} dataKey={dataKey} />;
    }

    return (
      <SimpleDataTable
        data={dataTable}
        columns={tableConfig}
        options={{ pagination: false }}
      />
    );
  }

  render() {
    const { year, menuName } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={() => this.handleSearch()}
          />
        </FlexView>
        <p className="margin-bottom-20px txt-site txt-main txt-bold">
          {menuName}
        </p>
        {this.renderContent()}
        <FlexView
          hAlignContent="right"
          className="margin-top-20px"
          style={{ gap: "20px" }}
        >
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
          <SimpleButton
            id="btn_print"
            text="CHART"
            onClick={() => this.handleChartVisibility()}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
